﻿<template>
    <span>{{ computedValue }}</span>
</template>
<script>
    import utils from "../utils/units";
    import * as common from "../utils/common";

    import { mapState, mapGetters } from 'vuex';

    export default {
        props: ['value'],
        computed: {
            ...mapState(["currentUser"]),
            ...mapGetters(["isMetric"]),
            computedValue() {
                if (this.isMetric) {
                    return utils.toKgString(this.value);
                }

                return utils.toLbString(this.value);
            }
        }
    }
</script>